import { lazy } from "react";
import { useSelector } from "react-redux";
import { DialogContent } from "@mui/material";
import { RootState } from "../../../redux/store";
import TPMDisbursement from "./TPMDisbursement";
import TPMDocumentUpload from "./TPMDocumentUpload";
import TPMUtilized from "./TPMUtilized";
import TPMGenerateMOU from "./TPMGenerateMOU";
import TPMApproveReject from "./TPMApproveReject";

const TriPartyMOUApproveReject = lazy(() => import("./TriPartyMOUApproveReject"));

const dialogsTypesWise: any = {
    "TriPartyMOUApproveReject": () => <TriPartyMOUApproveReject />,
    "TPMDisbursement": () => <TPMDisbursement />,
    "TPMdocumentupload": () => <TPMDocumentUpload />,
    "TPMFundUtilized": () => <TPMUtilized />,
    "TPMTPMGenerateMOU": () => <TPMGenerateMOU />,
    "TPMApproveReject": () => <TPMApproveReject />,

}

const dialogTypeFullScreen: any = {
}

const TriPartyMOUPage: React.FC = () => {
    const { type, isFullScreen } = useSelector((state: RootState) => state.dialog);

    return (
        <>
            {
                (isFullScreen && dialogTypeFullScreen[type]?.()) ?
                    (
                        <DialogContent sx={{ height: "100%", margin: 0, padding: 0 }}  > {dialogTypeFullScreen[type]?.() ?? null} </DialogContent>
                    ) : (
                        <>
                            { dialogsTypesWise[type]?.() ?? null }
                        </>
                    )
            }
        </>
    )
}
export default TriPartyMOUPage;
